import { render, staticRenderFns } from "./MatchBanner.vue?vue&type=template&id=e6ffe17c&scoped=true&"
import script from "./MatchBanner.vue?vue&type=script&lang=js&"
export * from "./MatchBanner.vue?vue&type=script&lang=js&"
import style0 from "./MatchBanner.vue?vue&type=style&index=0&id=e6ffe17c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6ffe17c",
  null
  
)

export default component.exports